var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlash1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 94,
    viewBox: "0 0 65 94",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.817 40.9197L59.3794 40.0071C59.6506 39.567 59.334 39 58.817 39H37.5C36.9083 39 36.4286 38.5203 36.4286 37.9286V6.22437V6.10978C36.4286 5.79277 36.0127 5.67491 35.8463 5.94479L5.9434 54.4691L5.49494 55.1969C5.27865 55.5478 5.53114 56 5.9434 56H27.2439H27.4475C28.0682 56 28.5714 56.5032 28.5714 57.1239V87.8894V87.9172C28.5714 88.5121 29.352 88.7333 29.6641 88.2268L58.817 40.9197Z",
    stroke: "white",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash1);
export default __webpack_public_path__ + "static/media/flash1.b24779f159cf4a467845b54f3d5c9759.svg";
export { ForwardRef as ReactComponent };